var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 114.615 114.615 0 256 0C397.385 0 512 114.615 512 256C512 397.385 397.385 512 256 512C114.615 512 0 397.385 0 256Z",
    fill: "#EB0028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.309 224.228H76V191H188.844V224.228H152.528V321.169H112.309V224.228ZM195.089 191H304.811V224.228H235.311V240.256H304.811V271.523H235.311V287.942H304.811V321.169H195.089V191ZM311.444 191H377.433C420.778 191 436 223.055 436 255.892C436 295.763 414.911 321.169 369.622 321.169H311.444V191ZM351.667 287.942H367.278C392.267 287.942 395.789 267.619 395.789 255.502C395.789 247.289 393.056 224.619 364.156 224.619H351.267L351.667 287.942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d73cee8d0531f0b70adcbb8727139abe.svg";
export { ForwardRef as ReactComponent };